import defaultPrimary from '../default/primary';

const secondary = (params) => defaultPrimary(params);

export default secondary;
